import { ApiResponse, makeApiCall } from "./index";

const BASE_URL = process.env.REACT_APP_API_AUTHENTICATION_URL;

// GET request
export function GetUsers(filters?: any): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}users`, "GET", filters);
}

// GET request
export function getUserById(userId: number): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}users/${userId}`, "GET");
}

// POST request
export function AddUser(body?: any): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}users`, "POST", body);
}

// PUT request
export function UpdateUser(userId: number, body?: any): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}users/${userId}`, "PUT", body);
}

// DELETE request
export function DeleteUser(userId: number): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}users/${userId}`, "DELETE");
}

// Restore request
export function restoreUser(userId: number): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}users/${userId}`, "PATCH");
}

// GET request
export function getUserRoles(clientId: string | null): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}UserRoles?clientId=${clientId}`, "GET");
}

// GET request
export function getUserPermissions(): Promise<ApiResponse> {
  return makeApiCall(`${BASE_URL}users/permissions`, "GET");
}

// Update request
export function ChangePasswordApi(
  userId: string | null,
  body?: any
): Promise<ApiResponse> {
  return makeApiCall(
    `${BASE_URL}users/${userId}/changePassword`,
    "PATCH",
    body
  );
}
